module.exports = __webpack_public_path__ + "img/2-1.4b1e3f44.svg";